export const DASHBOARD_REFRESH_EVENT = "bpm:refresh-dashboard";

export const emitDashboardRefresh = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(DASHBOARD_REFRESH_EVENT));
};

export const subscribeDashboardRefresh = (handler) => {
  if (typeof window === "undefined" || typeof handler !== "function") {
    return () => {};
  }
  window.addEventListener(DASHBOARD_REFRESH_EVENT, handler);
  return () => window.removeEventListener(DASHBOARD_REFRESH_EVENT, handler);
};
